<div :class="['n-modal-footer n-mt-8', wrapperClass]">
  <div class="modal-actions-wrapper n-flex n-align-center n-justify-end n-gap-4">
    <slot />
  </div>
</div>